module.exports = __webpack_public_path__ + "img/food_savior_icon.6e7b45fe.png";